"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
exports.StyledIcon = styled_components_1.default.svg `
  fill: ${({ color, theme }) => color || theme.palette.status.error};
`;
const AlertIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(exports.StyledIcon, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)("path", { d: "M10.493 2.935l-8.31 16.62C1.615 20.68 2.443 22 3.689 22h16.62a1.684 1.684 0 001.507-2.445l-8.31-16.62c-.618-1.247-2.396-1.247-3.013 0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M11.9 20.247a1.544 1.544 0 11.002-3.088 1.544 1.544 0 01-.001 3.088zM12.839 15.913l1.087-7.446c0-.654-.531-1.198-1.186-1.198H9.876l1.05 8.668 1.913-.024z", fill: "#fff" })] }));
exports.default = (0, IconContainer_1.default)(AlertIcon);
//# sourceMappingURL=index.js.map